import { CONNECTED_REQUESTS_MASS_EDIT_FIELDS } from '../../ConnectedRequestsMassEditModal.constants'

import { CategoryValueField } from './CategoryValueField'
import { DeadlineValueField } from './DeadlineValueField'
import { LabelsValueField } from './LabelsValueField'
import { ManagersValueField } from './ManagersValueField'
import { ProvidersValueField } from './ProvidersValueField'
import { StatusValueField } from './StatusValueField'
import { VisibilityValueField } from './VisibilityValueField'

function ValueField({ name, selectedFieldValue, ...restProps }) {
  switch (selectedFieldValue) {
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.status:
      return <StatusValueField {...restProps} name={name} />
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.visibility:
      return <VisibilityValueField {...restProps} name={name} />
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.category:
      return <CategoryValueField {...restProps} name={name} />
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.labels:
      return <LabelsValueField {...restProps} name={name} />
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.managers:
      return <ManagersValueField {...restProps} name={name} />
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.providers:
      return <ProvidersValueField {...restProps} name={name} />
    case CONNECTED_REQUESTS_MASS_EDIT_FIELDS.deadline:
      return <DeadlineValueField name={name} />
    default:
      return null
  }
}

export default ValueField
